import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06ce7b72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-faq" }
const _hoisted_2 = {
  href: "https://help.vrchat.com/hc/en-us/articles/1500002378722-System-Requirements/",
  target: "_blank"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = {
  href: "https://hello.vrchat.com/community-faq/",
  target: "_blank"
}
const _hoisted_5 = {
  href: "https://www.twitch.tv/vr_jmof/",
  target: "_blank"
}
const _hoisted_6 = {
  href: "https://www.twitch.tv/vr_jmof/",
  target: "_blank"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheDetailPageHeader = _resolveComponent("TheDetailPageHeader")!
  const _component_Heading = _resolveComponent("Heading")!
  const _component_SignalText = _resolveComponent("SignalText")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LinkButton = _resolveComponent("LinkButton")!
  const _component_TheDetailPageBody = _resolveComponent("TheDetailPageBody")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheDetailPageHeader, { class: "page-faq" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('page_title')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_TheDetailPageBody, null, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_1, [
          _createVNode(_component_Heading, { tag: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h2_1')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("dl", null, [
            _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('dt_1')), 1),
            _createElementVNode("dd", null, _toDisplayString(_ctx.$props.i18n.$text('dd_1')), 1)
          ]),
          _createElementVNode("dl", null, [
            _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('need_registration_question')), 1),
            _createElementVNode("dd", null, _toDisplayString(_ctx.$props.i18n.$text('need_registration_answer', 'answer_1')), 1)
          ]),
          _createElementVNode("dl", null, [
            _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('dt_3')), 1),
            _createElementVNode("dd", null, _toDisplayString(_ctx.$props.i18n.$text('dd_3')), 1)
          ]),
          _createElementVNode("dl", null, [
            _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('dt_4')), 1),
            _createElementVNode("dd", null, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('dd_4')), 1),
              _createVNode(_component_SignalText, { signal: "caution" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_1')), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("dl", null, [
            _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('access_question')), 1),
            _createElementVNode("dd", null, [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('access_answer', 'text_1')) + " ", 1),
              _createVNode(_component_router_link, { to: "/access" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('access_answer', 'link')), 1)
                ]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$props.i18n.$text('access_answer', 'text_2')), 1)
            ])
          ]),
          _createElementVNode("dl", null, [
            _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('time_table_question')), 1),
            _createElementVNode("dd", null, [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('time_table_answer', 'text_1')) + " ", 1),
              _createVNode(_component_router_link, { to: "/program/schedule" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('time_table_answer', 'link')), 1)
                ]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$props.i18n.$text('time_table_answer', 'text_2')), 1)
            ])
          ]),
          _createElementVNode("dl", null, [
            _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('program_question')), 1),
            _createElementVNode("dd", null, [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_answer', 'text_1')) + " ", 1),
              _createVNode(_component_router_link, { to: "/program" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_answer', 'link')), 1)
                ]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$props.i18n.$text('program_answer', 'text_2')), 1)
            ])
          ]),
          _createElementVNode("dl", null, [
            _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('dt_7')), 1),
            _createElementVNode("dd", null, _toDisplayString(_ctx.$props.i18n.$text('dd_7')), 1)
          ]),
          _createElementVNode("dl", null, [
            _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('dt_8')), 1),
            _createElementVNode("dd", null, _toDisplayString(_ctx.$props.i18n.$text('dd_8')), 1)
          ]),
          _createElementVNode("dl", null, [
            _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('dt_9')), 1),
            _createElementVNode("dd", null, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('dd_9_1')), 1),
              _createElementVNode("p", null, [
                _createElementVNode("a", _hoisted_2, _toDisplayString(_ctx.$props.i18n.$text('link_1')), 1),
                _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('dd_9')), 1)
              ]),
              _createElementVNode("table", null, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('td_1')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('td_2')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('td_3')), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('td_4')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('td_5')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('td_6')), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('td_7')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('td_8')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('td_9')), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('td_10')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('td_11')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('td_12')), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('td_13')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('td_14')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('td_15')), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('td_16')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('td_17')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('td_18')), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('td_19')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('td_20')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('td_21')), 1)
                  ])
                ])
              ]),
              _createVNode(_component_SignalText, { signal: "caution" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_2')), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("dl", null, [
            _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('notwork_question')), 1),
            _createElementVNode("dd", null, _toDisplayString(_ctx.$props.i18n.$text('notwork_answer')), 1)
          ]),
          _createElementVNode("dl", null, [
            _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('dt_10')), 1),
            _createElementVNode("dd", null, [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('dd_10_1')), 1),
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_ctx.$props.i18n.$text('dd_10_2')), 1),
              _createElementVNode("a", _hoisted_4, _toDisplayString(_ctx.$props.i18n.$text('link_2')), 1),
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('dd_10_3')), 1)
            ])
          ]),
          _createElementVNode("dl", null, [
            _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('platform_question')), 1),
            _createElementVNode("dd", null, _toDisplayString(_ctx.$props.i18n.$text('platform_answer')), 1)
          ]),
          _createElementVNode("dl", null, [
            _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('user_stream_question')), 1),
            _createElementVNode("dd", null, [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('user_stream_answer', 'text_1')) + " ", 1),
              _createVNode(_component_router_link, { to: "/terms" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('user_stream_answer', 'link')), 1)
                ]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$props.i18n.$text('user_stream_answer', 'text_2')), 1)
            ])
          ]),
          _createElementVNode("dl", null, [
            _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('live_stream_question')), 1),
            _createElementVNode("dd", null, [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('live_stream_answer', 'text_1')) + " ", 1),
              _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.$props.i18n.$text('live_stream_answer', 'link')), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.$props.i18n.$text('live_stream_answer', 'text_2')), 1)
            ])
          ]),
          _createElementVNode("dl", null, [
            _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('instance_abnormal_question')), 1),
            _createElementVNode("dd", null, [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('instance_abnormal_answer', 'answer_1', 'text_1')) + " ", 1),
              _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.$props.i18n.$text('instance_abnormal_answer', 'answer_1', 'link')), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.$props.i18n.$text('instance_abnormal_answer', 'answer_1', 'text_2')), 1),
              _hoisted_7,
              _createTextVNode(" " + _toDisplayString(_ctx.$props.i18n.$text('instance_abnormal_answer', 'answer_2')), 1)
            ])
          ]),
          _createElementVNode("dl", null, [
            _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('after_avatars_question')), 1),
            _createElementVNode("dd", null, _toDisplayString(_ctx.$props.i18n.$text('after_avatars_answer')), 1)
          ]),
          _createElementVNode("dl", null, [
            _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('dt_13')), 1),
            _createElementVNode("dd", null, _toDisplayString(_ctx.$props.i18n.$text('dd_13')), 1)
          ]),
          _createElementVNode("dl", null, [
            _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('event_inside_question')), 1),
            _createElementVNode("dd", null, [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('event_inside_answer', 'text_1')) + " ", 1),
              _createVNode(_component_router_link, { to: "/program" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('event_inside_answer', 'link')), 1)
                ]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$props.i18n.$text('event_inside_answer', 'text_2')), 1)
            ])
          ]),
          _createElementVNode("dl", null, [
            _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('myevent_instances_question')), 1),
            _createElementVNode("dd", null, [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('myevent_instances_answer', 'text_1')) + " ", 1),
              _createVNode(_component_router_link, { to: "/access/instances" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('myevent_instances_answer', 'link')), 1)
                ]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$props.i18n.$text('myevent_instances_answer', 'text_2')), 1)
            ])
          ])
        ]),
        _createElementVNode("section", null, [
          _createVNode(_component_Heading, { tag: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h2_2')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_1')), 1),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_3')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Heading, { tag: "h3" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h3_1')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_2')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_3')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_4')), 1),
          _createVNode(_component_LinkButton, {
            href: "https://forms.gle/2kJu3hmesv8Ukqcm6",
            "is-external": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('link_3')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}